import React from "react";

import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { PayHistoryComponent } from "./PayHistoryComponent";
import { useCookie } from "../../utils";

function PayHistory() {
  const branch_id = useCookie("branch_id");
  return (
    <PayHistoryComponent
      TopBar={Topbar}
      SideBar={Sidebar}
      branch_id={branch_id}
    />
  );
}

export default PayHistory;
